<template>
  <div class="meeting-container">
    <meetingList-list v-show="tabType === 1" @handleShow="handleShow" />
    <meetingList-show
      v-if="tabType === 2"
      :rowItem="rowItem"
      @handleShow="handleShow"
    />
  </div>
</template>

<script>
import meetingListList from "./list.vue";
import meetingListShow from "./show.vue";
export default {
  components: { meetingListList, meetingListShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    };
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row };
      this.tabType = type;
    }
  }
};
</script>

<style lang="scss" scoped>
.meeting-container {
  height: 100%;
}
</style>
